// extracted by mini-css-extract-plugin
export default {"wrapper":"Zj","form":"_j","circle":"ak","success":"bk","button":"ck"};